var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyberArk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4766 19.472L33.1061 19.2605L23.7892 13.8865L14.3707 19.3215V30.1426L14.5009 30.2155L23.7892 35.5531L33.3379 30.065V24.0367L28.5004 26.8175V22.3297L33.468 19.476L33.4761 19.472H33.4766ZM24.0787 20.0738L27.9718 22.3257V26.8175L24.0787 24.5696V20.0733V20.0738ZM23.5129 14.6673V19.4554L19.3514 21.8618L15.1848 19.472L23.5123 14.6667L23.5129 14.6673ZM23.5129 20.0738V24.5696L19.6204 26.8175V22.3257L23.5129 20.0738ZM14.9171 19.9353L19.0825 22.3257V27.1264L14.9165 29.5327V19.9353H14.9171ZM15.198 29.9921L19.3514 27.5898L23.5214 29.9881L23.5294 34.7768L15.1974 29.9921H15.198ZM23.7938 29.5207H23.7898L19.8847 27.2808L23.7772 25.033L23.7938 25.041L23.8103 25.033L27.7029 27.2808L27.2547 27.5368L23.7978 29.5247H23.7938V29.5207ZM28.7739 27.2808L32.8052 24.9595V29.7481L32.3901 29.9881L24.0587 34.7728L24.0667 29.9841L28.7739 27.2768V27.2808ZM28.2407 21.8623L24.0792 19.456V14.6667L32.4067 19.4714L28.2413 21.8618L28.2407 21.8623Z",
    fill: "url(#paint0_linear_32636_170646)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7943 35.7157L14.2371 30.2237V19.2363L23.7943 13.7197L33.7626 19.4716L28.6523 22.4109V26.5732L33.4897 23.793V30.1507L23.7943 35.7197V35.7157ZM14.522 30.0573L14.579 30.0898L23.7983 35.3863L33.2088 29.9798V24.2809L28.3714 27.0616V22.2445L33.1968 19.4722L23.7983 14.0492L14.522 19.4027V30.0573ZM23.9199 35.0249L23.9279 29.9068L32.9513 24.7157V29.8333L23.9199 35.0204V35.0249ZM24.2128 30.0698L24.2048 34.5291L32.6665 29.6674V25.2042L24.2128 30.0658V30.0698ZM23.671 35.0249L14.913 29.9923L19.3514 27.427L23.6636 29.9068L23.6716 35.0249H23.671ZM15.4828 29.9923L23.3867 34.5331L23.3787 30.0738L19.3514 27.761L15.4828 29.9969V29.9923ZM14.7743 19.6911L19.2252 22.2479V27.211L14.7743 29.7849V19.6911ZM15.0598 20.183V29.2884L18.9403 27.0446V22.4103L15.0598 20.183ZM23.7903 29.6868L19.6003 27.2805L23.7783 24.8702L27.9889 27.2805L23.7989 29.6868H23.7903ZM23.7903 29.3574H23.7943L27.4185 27.28L23.7903 25.1905L20.1701 27.28L23.7903 29.3614V29.3574ZM19.4781 27.0645V22.2433L23.6562 19.8284V24.6536L19.4781 27.0639V27.0645ZM19.759 22.4057V26.5681L23.3667 24.4866V20.3215L19.759 22.4069V22.4057ZM28.115 27.0645L23.937 24.6542V19.8295L28.115 22.2445V27.0656V27.0645ZM24.2225 24.4872L27.8302 26.5686V22.4063L24.2225 20.3209V24.4872ZM28.2418 22.0279L23.9376 19.54V14.423L32.6921 19.4756L28.2412 22.0324V22.0284L28.2418 22.0279ZM24.2225 19.3736L28.2418 21.699L32.1223 19.4711L24.2213 14.9149V19.3742L24.2225 19.3736ZM19.3525 22.0279L14.901 19.4716L23.6556 14.4191V19.5366L19.3514 22.0245V22.0284L19.3525 22.0279ZM15.4708 19.4716L19.3514 21.6995L23.3707 19.3742V14.9149L15.4708 19.4716Z",
    fill: "url(#paint1_linear_32636_170646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32636_170646",
    x1: 24.0084,
    y1: 12.4484,
    x2: 24.0084,
    y2: 37.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32636_170646",
    x1: 24.0084,
    y1: 12.4484,
    x2: 24.0084,
    y2: 37.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberArk);
export default __webpack_public_path__ + "static/media/CyberArk.639b742af9108bb4627ceecb4900d4c5.svg";
export { ForwardRef as ReactComponent };